import React from 'react';
import ImageUtils from '@gik/core/utils/ImageUtils';
import PrimaryTaxonomyItemLink from './PrimaryTaxonomyItemLink';
import Article from '../models/Article';

interface ArticleHeaderProps {
  article: Article;
}

export default class ArticleHeader extends React.PureComponent<ArticleHeaderProps> {
  render() {
    return (
      <header className="article-header featured">
        <aside
          className="column-1 image"
          style={{ backgroundImage: ImageUtils.imageOrNotFoundGradient(this.props.article.largeImageUrl) }}
        ></aside>
        <main className="column-2">
          <div className="content">
            <PrimaryTaxonomyItemLink articleLink={this.props.article} />
            <div className="title">
              <h1>
                {this.props.article.title}{' '}
                {this.props.article.isPreviewOnly && <span style={{ color: 'red' }}>PREVIEW</span>}
              </h1>
            </div>
          </div>
        </main>
      </header>
    );
  }
}
